import { keymirror } from 'utils/keymirror'

export const SHIPMENTS_TAB = 'shipments'
export const TRACKING_TAB = 'tracking'
export const DRIVER_LOCATIONS_TAB = 'driver-locations'
export const LOGS_TAB = 'logs'

export const USER_PROFILE_TABS = keymirror({
  [SHIPMENTS_TAB]: undefined,
  [TRACKING_TAB]: undefined,
  [DRIVER_LOCATIONS_TAB]: undefined,
  [LOGS_TAB]: undefined,
})
